import React from 'react';

export default function TabelaClientes({ clientes, onDelete }) {
  if (clientes.length === 0) return <div className="mt"><span className="mt-ico">👥</span>Nenhum cliente cadastrado.</div>;

  return (
    <div className="lst">
      {clientes.map((c) => (
        <div key={c.id} className="it">
          <div className="it-main">
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <strong style={{ fontSize: 14 }}>{c.nome}</strong>
              <span className="bd bd-g">{c.total_pedidos} pedidos</span>
            </div>
            {c.telefone && <div style={{ fontSize: 12, color: 'var(--c4)', marginTop: 2 }}>{c.telefone}</div>}
          </div>
          <button className="btn btn3 btn-sm" onClick={() => onDelete(c)} style={{ flexShrink: 0 }}>x</button>
        </div>
      ))}
    </div>
  );
}
